module.exports = __webpack_public_path__ + "img/opinions-active.f371a0df.svg";